(ns frontend.ui.page.lp-portal.landing-page.event
  (:require
   [common.util :as cu]
   [frontend.controller.websocket.event :as ws]
   [frontend.lp-portal.routes :as routes]
   [re-frame.core :as rf]
   [reitit.frontend.easy :as reitit-e]
   [frontend.logging :as logging]
   [frontend.controller.routing.event :as routing-event]
   [frontend.lp-portal.sub :as portal-sub]
   [ajax.core :as ajax]
   [frontend.ui.page.lp-portal.landing-page.sub :as sub]))

(rf/reg-event-fx
 ::on-news-items-received
 (fn [{:keys [db] :as cofx} [_ {:keys [body] :as args}]]
   {:db (assoc db :news-items-loading false :news-items body)}))

(rf/reg-event-fx
 ::on-news-items-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   {:db (assoc db :news-items-loading false)}))

(rf/reg-event-fx
 ::news-items
 (fn [{:keys [db] :as cofx} [_ args]]
   (let [year (:selected-news-year db)
         type (:selected-news-type db)
         category (:selected-news-category db)]
     {:db         (assoc db :news-items-loading true)
      :http-xhrio {:method          :post
                   :uri             "/lp-portal/api/get-news"
                   :params          (merge {}
                                           (when-not (cu/blank-value? year) {:year year})
                                           (when type {:type type})
                                           (when category {:category category}))
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::on-news-items-received]
                   :on-failure      [::on-news-items-failed]}}
   )))

(rf/reg-event-fx
 ::news-year
 (fn [{:keys [db] :as cofx} [_ year]]
   {:db (assoc db :selected-news-year year)
    :fx [[:dispatch [::news-items]]]}))

(rf/reg-event-fx
 ::news-type
 (fn [{:keys [db] :as cofx} [_ type]]
   {:db (assoc db :selected-news-type type)
    :fx [[:dispatch [::news-items]]]}))

(rf/reg-event-fx
 ::news-category
 (fn [{:keys [db] :as cofx} [_ category]]
   {:db (assoc db :selected-news-category category)
    :fx [[:dispatch [::news-items]]]}))

(rf/reg-event-fx
 ::reset-filters
 (fn [{:keys [db] :as cofx} [_ args]]
   {:db (assoc db
               :selected-news-type nil
               :selected-news-category nil
               :selected-news-year nil)
    :fx [[:dispatch [::news-items]]]}))

(rf/reg-event-fx
 ::set-feeder-commitments-sort-order
 (fn [{:keys [db] :as cofx} [_ sort-order]]
   {:db (assoc-in db sub/feeder-commitments-sort-path sort-order)}))

(rf/reg-event-fx
 ::set-commitments-sort-order
 (fn [{:keys [db] :as cofx} [_ sort-order]]
   {:db (assoc-in db sub/commitments-sort-path sort-order)}))

(rf/reg-event-fx
 ::set-funds-sort-order
 (fn [{:keys [db] :as cofx} [_ sort-order]]
   {:db (assoc-in db sub/funds-sort-path sort-order)}))

(rf/reg-event-fx
 ::on-landing-page-data
 (fn [{:keys [db] :as cofx} [_ {:keys [body] :as args}]]
   (merge {:db (-> db
                   (assoc-in sub/landing-page-data-path body)
                   (assoc-in [:landing-page-loading] false))}
          (when (not= (get-in (:view-route db) [:data :name]) ::routes/report-view)
            (do
              {::routing-event/push-state {:handler ::routes/landing-page}})))))

(rf/reg-event-fx
 ::on-landing-page-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   {:db (-> db
            (assoc-in portal-sub/portal-status-path :lp-portal.status/error)
            (assoc-in [:landing-page-loading] false))}))

(rf/reg-event-fx
 ::landing-page-data
 (fn [{:keys [db] :as cofx} args]
   (logging/performance "Start load Landing page data")
   {:db         (assoc-in db [:landing-page-loading] true)
    :http-xhrio {:method          :post
                 :uri             "/lp-portal/api/landing-page-data"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-landing-page-data]
                 :on-failure      [::on-landing-page-failed]}}))

(rf/reg-event-fx
 ::latest-reports-active-tab-key
 (fn [{:keys [db] :as cofx} [_ active-tab-key]]
   {:db (assoc db :lp-latest-reports-active-tab-key active-tab-key)}))

(rf/reg-event-fx
 ::on-promotion-deleted
 (fn [{db :db} [_ args]]
   (set! js/location.href "/")
   {}))

(rf/reg-event-fx
 ::on-promotion-deletion-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "event/on-promotion-deletion-failed")
   {}))

(rf/reg-event-fx
 ::delete-promotion
 (fn [{:keys [db] :as cofx} [_ promotion-id]]
   {:http-xhrio {:method          :post
                 :uri             "/lp-portal/api/delete-lp-promotion"
                 :params          {:promotion-id promotion-id}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-promotion-deleted]
                 :on-failure      [::on-promotion-deletion-failed]}}))

(rf/reg-event-fx
 ::open-report
 (fn [{db :db} [_ report-id]]
   ;; ugly hack - we'd rather want to have this as FX ?
   (reitit-e/push-state ::routes/report-view {:id report-id})))

(rf/reg-event-fx
 ::on-news-item-deleted
 (fn [{db :db} [_ args]]
   (set! js/location.href "/")
   {}))

(rf/reg-event-fx
 ::on-news-item-deletion-failed
 (fn [{:keys [db] :as cofx} [_ args]]
   (js/console.log "event/on-news-item-deletion-failed")
   {}))

(rf/reg-event-fx
 ::delete-news-item
 (fn [{:keys [db] :as cofx} [_ news-item-id]]
   {:http-xhrio {:method          :post
                 :uri             "/lp-portal/api/delete-lp-news-item"
                 :params          {:news-item-id news-item-id}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-news-item-deleted]
                 :on-failure      [::on-news-item-deletion-failed]}}
 ))

(rf/reg-event-fx
 ::open-pdf-ok
 (fn [{db :db} [_ resp]]
   (let [body (:body resp)
         url (:download-url body)
         w (when url
             (.open js/window "about:blank" "_blank"))]
     (when w
       (aset w "location" (:download-url body)))
     {})))

(rf/reg-event-fx
 ::open-pdf-failed
 (fn [{:keys [db] :as cofx} [_ err]]
   (js/console.log "event/open-pdf-failed " err)
   {}))


(rf/reg-event-fx
 ::open-pdf
 (fn [{db :db} [_ report-id]]
   {:http-xhrio {:method          :post
                 :uri             "/lp-portal/api/download-report"
                 :params          {:report-id      report-id
                                   :selected-items [:fund-report]
                                   :show?          true}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::open-pdf-ok]
                 :on-failure      [::open-pdf-failed]}}))

(rf/reg-event-fx
  ::highcharts-tooltip-cleanup
  (fn [{db :db} [_ args]]
    (let [tooltip-elements (vec
                             (array-seq
                               (.getElementsByClassName js/document "highcharts-tooltip-container")))]
      (when-not (empty? tooltip-elements) (doseq [elem tooltip-elements]
                                            (.remove elem))))
    {}))

